// extracted by mini-css-extract-plugin
export default {"copy-icon":"j6zPeOrLjBASONyWNVyH","report-link":"neT_ftTA6GnYerggsPPH","link":"eD12GqGnsFQairgza4bf"};